export default __webpack_public_path__ + "e6b359e12087cb2204fbf12ab95927b7.svg";